import React from "react";
import { useHalloween } from "./HalloweenProvider";

export default function HalloweenBanner() {
  const { enabled, banner_text } = useHalloween();
  if (!enabled || !banner_text) return null;

  return (
    <div className="hk-banner" data-testid="halloween-banner" role="status">
      <span className="hk-banner-ember" aria-hidden="true" />
      <p className="hk-banner-text font-display" data-testid="halloween-banner-text">{banner_text}</p>
      <span className="hk-banner-ember" aria-hidden="true" />
    </div>
  );
}
